<div class='container'>

  <!-- <iframe src='https://view.officeapps.live.com/op/embed.aspx?src=http%3A%2F%2Fieee802%2Eorg%3A80%2Fsecmail%2FdocIZSEwEqHFr%2Edoc' width='100%' height='1000' frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe> -->
  &nbsp;
  <h1>社企活動</h1>
  <h2>藝術與健康長者論壇暨展覽 - 2026年3月21日 </h2>
  <img src="assets/images/6746cc31-e054-48bb-bc34-d77ce83f81f3.jpeg" alt="藝術與健康長者論壇暨展覽 - 2026年3月21日" class="img-fluid">
  &nbsp;
  <iframe
    *ngIf="playlistEmbedUrl"
    class="frame"
    [src]="playlistEmbedUrl"
    title="YouTube 播放清單"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowfullscreen
    loading="lazy"
  ></iframe>
  <nav
  *ngIf="playlistToc.length"
  class="playlist-toc card mb-3"
  aria-label="播放清單目錄"
>
  <div class="card-header py-2 playlist-toc-heading">影片目錄</div>
  <div class="card-body py-2">
    <ol class="playlist-toc-list mb-0">
      <li *ngFor="let item of playlistToc" class="playlist-toc-item">
        <button
          type="button"
          class="playlist-toc-btn"
          (click)="selectPlaylistVideo(item)"
        >
          {{ item.title }}
        </button>
      </li>
    </ol>
  </div>
</nav>
  &nbsp;
  <!-- <iframe class="frame" src="https://drive.google.com/file/d/1QF5G7iSJ13x2VPJ3LXnx2YHD76kEA8tf/preview"></iframe> -->
</div>
